<lib-game-view [id]="id" [gameType]="game_type"></lib-game-view>